export default __webpack_public_path__ + "static/media/img_3.845634b6.JPG";